import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Badges from './components/Badges';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppFloat from './components/WhatsAppFloat';

function App() {
  return (
    <>
      <Header />
      <Hero />
      <Badges />
      <About />
      <Services />
      <Products />
      <Gallery />
      <Contact />
      <Footer />
      <WhatsAppFloat />
    </>
  );
}

export default App;
